import { Invoicing } from './components';

export function AccountHistoryContent() {
  return <Invoicing />;
}
